<template>
  <div :class="{ 'has-logo': showLogo }">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="$store.state.settings.uniqueOpened"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        @select="handelSelect"
        mode="vertical"
      >
        <sidebar-item v-for="route in permission_routers" :key="route.path" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'
import { mapGetters } from 'vuex'
export default {
  inject: ['reload'],
  components: { Logo, SidebarItem },
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['permission_routers', 'sidebar']),
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    isCollapse() {
      return !this.sidebar.opened
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the Sidebar will highlight the path you set
      // console.log('meta.activeMenu:' + meta.activeMenu)
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    variables() {
      return variables
    },
  },
  created() {
    // console.log('this.', this.activeMenu)
  },
  methods: {
    handelSelect(index, indexPath) {
      /**
       * 找到设置了缓存的菜单noCache === false, 清除缓存
       */
      let _routers = this.permission_routers
      let _curRouter = ''
      for (let i = 0; i < _routers.length; i++) {
        if (index === _routers[i].path && _routers[i].meta && _routers.meta.noCache === false) {
          _curRouter = _routers[i]
          break
        } else if (_routers[i].children) {
          for (let j = 0; j < _routers[i].children.length; j++) {
            let sub = _routers[i].children[j]
            let tempPath = _routers[i].path + '/' + sub.path
            if (index === tempPath) {
              _curRouter = sub
              break
            }
          }
        }
      }
      if (_curRouter) {
        this.$store.dispatch('tagsView/delCachedView', _curRouter)
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/Index.vue